export default __webpack_public_path__ + "static/media/text-icon.3335b7c0.svg";